var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"512","height":"512","rx":"15%","fill":"#d43377","key":0}),React.createElement("g",{"fill":"none","stroke":"#fff","strokeWidth":"29","key":1},[React.createElement("rect",{"height":"296","rx":"78","width":"296","x":"108","y":"108","key":0}),React.createElement("circle",{"cx":"256","cy":"256","r":"69","key":1})]),React.createElement("circle",{"cx":"343","cy":"169","fill":"#fff","r":"19","key":2})]);
}

Instagram.defaultProps = {"aria-label":"Instagram","role":"img","viewBox":"0 0 512 512"};

module.exports = Instagram;

Instagram.default = Instagram;
